var Sliders = function () {

};

Sliders.prototype.logger = null;
Sliders.prototype.on_duration = 4;
Sliders.prototype.transition_duration = 2;
Sliders.prototype.intervalH = [];

Sliders.prototype.init = function () {
    if ( this.intervalH.length > 0 ) {
        return;
    } else {
        //console.log("Starting slider");
    }

    var that = this;

    var allSliders = document.querySelectorAll('div[data-core6_slider]');
    for ( var i = 0; i < allSliders.length; i++ ) {
        that.setupSlider(allSliders[i]);
    }

    $('body').on('click', '.slider_arrow_prev', function (evt) {
        evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

        ////console.log(evt.target.parentNode);
        var item = evt.target.parentNode;
        var slider_images = item.dataset.core6_slider_images;
        //this.info("Images 1", slider_images);
        if ( slider_images === undefined || slider_images.split(';').length < 2 ) {
            return;
        }
        slider_images = slider_images.split(';');

        if (item.dataset.core6_slider_current_image_index === undefined) {
            item.dataset.core6_slider_current_image_index = 0;
        } else if ((item.dataset.core6_slider_current_image_index*1) === 0) {
            item.dataset.core6_slider_current_image_index = slider_images.length -1;
        } else {
            item.dataset.core6_slider_current_image_index = (item.dataset.core6_slider_current_image_index*1) - 1;
        }

        var remClass = item.querySelectorAll('li');
        for (var x = 0; x < remClass.length; x++) {
            if ( x === (item.dataset.core6_slider_current_image_index*1) ) {
                remClass[x].classList.add('secondary_colour');
            } else {
                remClass[x].classList.remove('secondary_colour');
            }
        }

        item.style.backgroundImage = "url('/large/" + slider_images[item.dataset.core6_slider_current_image_index]+"')";
        return false;
    });

    $('body').on('click', '.slider_arrow_next', function (evt) {
        evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

        ////console.log(evt.target.parentNode);
        var item = evt.target.parentNode;
        var slider_images = item.dataset.core6_slider_images;
        //this.info("Images 1", slider_images);
        if ( slider_images === undefined || slider_images.split(';').length < 2 ) {
            return;
        }
        slider_images = slider_images.split(';');

        that.move_next(item, slider_images);
        return false;
    });

    $('body').on('click', '.slider_numbers>li', function (evt) {
        evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

        var remClass = evt.target.parentNode.querySelectorAll('li');
        for (var x = 0; x < remClass.length; x++) {
            remClass[x].classList.remove('secondary_colour');
        }
        evt.target.classList.add('secondary_colour');

        var item = evt.target.parentNode.parentNode;
        var indexToSet = evt.target.dataset.core6_set_active_image * 1; var slider_images = item.dataset.core6_slider_images;
        //this.info("Images 1", slider_images);
        if ( slider_images === undefined || slider_images.split(';').length < 2 ) {
            return;
        }
        slider_images = slider_images.split(';');
        item.dataset.core6_slider_current_image_index = indexToSet;
        item.style.backgroundImage = "url('/large/" + slider_images[item.dataset.core6_slider_current_image_index]+"')";
        return false;
    });

    document.querySelector('body').addEventListener('onsliderreset', function (e) {
        //console.log("resetting slider");
        that.reset(that);
    }, false);
};

Sliders.prototype.reset = function (slider_handle) {
    for (var k in slider_handle.intervalH) {
        k = k * 1;
        //console.log("clearing interval " + k);
        clearInterval(slider_handle.intervalH[k]);
    }

    slider_handle.intervalH = [];

    //console.log(slider_handle.intervalH);

    if ( slider_handle.intervalH.length === 0 ) {
        //console.log("starting new slider");
        var that = slider_handle;

        var allSliders = document.querySelectorAll('div[data-core6_slider]');
        for ( var i = 0; i < allSliders.length; i++ ) {
            that.setupSlider(allSliders[i]);
        }
    }
};

Sliders.prototype.setupSlider = function (item) {
    //this.info("Add slider to component", item);

    var slider_images,
        slider_transition,
        slider_show_arrows,
        slider_show_numbers;

    slider_images = item.dataset.core6_slider_images;
    //this.info("Images 1", slider_images);
    if ( slider_images === undefined || slider_images.split(';').length < 2 ) {
        return;
    }

    slider_images = slider_images.split(';');
    slider_transition = item.dataset.core6_slider_transition;
    slider_show_arrows = item.dataset.core6_slider_show_arrows;
    slider_show_numbers = item.dataset.core6_slider_show_numbers;
    sliderScrollTime = item.dataset.core6_scroll_time;

    //this.info("Images", slider_images);
    //this.info("Transition", slider_transition);


    if ( sliderScrollTime !== "0" && sliderScrollTime !== 0 ) {
        this.on_duration = (sliderScrollTime * 1);

        // Cache the images to stop flickering
        slider_images.forEach(function (img) {
            new Image().src = "/large/" + img;
        });

        this.fadeTransition(item, slider_images);
    } else {
        this.move_next(item, slider_images);
    }
};

Sliders.prototype.fadeTransition = function (item, slider_images) {
    var that = this;
    that.move_next(item, slider_images);
    var inter = setInterval(function () {
        that.move_next(item, slider_images);
    }, that.on_duration * 1000);
    that.intervalH.push(inter);
};

Sliders.prototype.move_next = function (item, slider_images) {
    if ( item.dataset.core6_slider_current_image_index === undefined || ((item.dataset.core6_slider_current_image_index * 1) + 1) > (slider_images.length -1) ) {
        item.dataset.core6_slider_current_image_index = 0;
    } else {
        item.dataset.core6_slider_current_image_index = (item.dataset.core6_slider_current_image_index * 1) + 1;
    }

    var remClass = item.querySelectorAll('li');
    for (var x = 0; x < remClass.length; x++) {
        if ( x === (item.dataset.core6_slider_current_image_index*1) ) {
            remClass[x].classList.add('secondary_colour');
        } else {
            remClass[x].classList.remove('secondary_colour');
        }
    }

    item.style.backgroundImage = "url('/large/" + slider_images[item.dataset.core6_slider_current_image_index]+"')";
};

Sliders.prototype.info = function (title, info) {
    var styles = [
        , 'color: black'
        , 'display: block'
        , 'text-align: center'
        , 'font-weight: bold'
    ].join(';');

    //console.log("");
    //console.log("%c" + title, styles);
    //console.log(info);
};


(function () {
    var sliders = new Sliders();
    sliders.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/core6/sliders.js